export default __webpack_public_path__ + "static/media/sweet-1.6a6ef41a.jpg";